import React, { Fragment, useEffect, useRef, useState, useCallback } from "react";
import * as ReactDOM from "react-dom";
import { Alert, Badge, Card, CardBody, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import debounce from "lodash/debounce";
import { useDispatch, useSelector } from "react-redux";
import { setSkuDialog } from "../../../store/prodcutSlice";
import TagsInput from "react-tagsinput";
import { ModalFooter } from "react-bootstrap";
import CustomTagsInput from "../../../../../share-components/ui/customTagsInput";
import Select from "react-select";
import {
  codeWithColourAutoSuggestion,
  codeWithMainWiseColourAutoSuggestion,
  variantColourWiseAutoSuggestion,
} from "../../../../../services/manage-product/productService";

const SkuDetails = (props) => {
  const { setValue, trigger, getValues, imageSelectOnClick, skuOnClick, errors } = props;
  const dispatch = useDispatch();
  const productState = useSelector(({ product }) => product.product.skuDialogProps);
  const colourId = productState.data ? productState.data.colour_id : "";
  const rowIndex = productState.data ? productState.data.rowIndex : "";
  const colourName = productState.data ? productState.data.colour : "";
  const [sku, setSku] = useState([]);
  const [isChange, setIsChange] = useState(false);

  const [isThirdPartySeller, setIsThirdPartySeller] = useState(false);
  // Looklab Products

  const [looklabProductsOptions, setLooklabProductsOptions] = useState([]);
  const [pageLooklabProducts, setPageLooklabProducts] = useState(1);
  const [hasMoreLooklabProducts, setHasMoreLooklabProducts] = useState(true);
  const [loadingLooklabProducts, setLoadingLooklabProducts] = useState(false);
  const [queryLooklabProducts, setQueryLooklabProducts] = useState("");

  useEffect(() => {
    setIsThirdPartySeller(getValues("is_third_party_seller"));
  }, []);

  const closDialog = () => {
    dispatch(setSkuDialog({ props: false }));
  };


  useEffect(() => {
    if (colourId) {
      let skuData = [];
      const colourData = getValues("color").find((x) => x.id == colourId);
      if (getValues("selling_type").find((x) => x.id === 1)) {
        getValues("size").map((item, index) => {
          const sku = (getValues("code") + "-" + colourData.name + "-" + item.name).toLocaleLowerCase().replaceAll(" ", "");
          skuData.push({ sku: sku, colour: colourData.id, size: item.id });
        });
      }
      if (getValues("selling_type").find((x) => x.id === 2)) {
        const sku = (getValues("code") + "-" + colourData.name + "-pack").toLocaleLowerCase().replaceAll(" ", "");
        skuData.push({ sku: sku, colour: colourData.id, size: 1 });
      }
      setSku(skuData);
    }
  }, [colourId]);

  const fetchLooklabProductsOptions = async (inputValue, page) => {
    if (loadingLooklabProducts || !hasMoreLooklabProducts) return;

    setLoadingLooklabProducts(true);

    try {
      let searchData = {
        q: inputValue,
        page: page,
        page_size: 10,
      };

        // const response = await variantColourWiseAutoSuggestion(searchData);
      const response = await codeWithMainWiseColourAutoSuggestion(searchData);

      const newOptions = response.response;

      setLooklabProductsOptions((prevOptions) => (page === 1 ? newOptions : [...prevOptions, ...newOptions]));
      setHasMoreLooklabProducts(newOptions.length === 10);
      setPageLooklabProducts(page + 1);
      setLoadingLooklabProducts(false);
    } catch (error) {
      setLoadingLooklabProducts(false);

      console.error("Error fetching options:", error);
    }
  };

  const updateBinDetails = (sizeId, value, isBin, lookbook = null) => {
    if (colourId) {
      const binNumbers = getValues("bin_numbers");
      const dataIndex = binNumbers.findIndex((x) => x.size_id == sizeId && x.colour_id == colourId);
      if (dataIndex == -1) {
        let data = {
          size_id: sizeId,
          colour_id: colourId,
          bin_number: isBin ? value : [],
          gtn_number: !isBin ? value : "",
          available_in_looks: lookbook ? value : [],
        };
        binNumbers.push(data);
      } else if (lookbook) {
        binNumbers[dataIndex].available_in_looks = value;
      } else {
        if (isBin) {
          binNumbers[dataIndex].bin_number = value;
        } else {
          binNumbers[dataIndex].gtn_number = value;
        }
      }
      setValue("bin_numbers", binNumbers);
    }
  };

  const debouncedFetchLooklabProductsOptions = useCallback(
    debounce((inputValue, page) => fetchLooklabProductsOptions(inputValue, page), 500),
    []
  );

  const handleInputChangeLooklabProducts = (inputValue) => {
    setPageLooklabProducts(1);
    setHasMoreLooklabProducts(true);
    setQueryLooklabProducts(inputValue);
    debouncedFetchLooklabProductsOptions(inputValue, 1);
  };

  const handleMenuScrollToBottomLooklabProducts = () => {
    if (hasMoreLooklabProducts) {
      fetchLooklabProductsOptions(queryLooklabProducts, pageLooklabProducts);
    }
  };

  const handleMenuOpenLooklabProducts = () => {
    fetchLooklabProductsOptions(queryLooklabProducts, 1);
  };

  const binValue = (item) => {
    const binValue = getValues("bin_numbers").find((binItem) => binItem.size_id == item.size && binItem.colour_id == colourId);
    return binValue ? binValue.bin_number : [];
  };

  return (
    <Fragment>
      <div className="form-row mb-3">
        <Modal
          size="xl"
          {...productState.props}
          toggle={() => {
            closDialog();
          }}
        >
          <ModalHeader
            toggle={() => {
              closDialog();
            }}
          >
            {colourName + "'s sku"}
          </ModalHeader>
          <ModalBody>
            <Row className="product-name mb-3">
              <Col md={3} className="text-center">
                <strong>SKU</strong>
              </Col>
              <Col md={3} className="text-center">
                <strong>GTN Number</strong>
              </Col>
              <Col md={4} className="text-center">
                <strong>BIN Number</strong>
              </Col>
            </Row>
            {sku.map((item, i) => (
              <Row key={i + "-" + colourId} className="mb-1">
                <Col sm={12}>
                  <div className="" style={{ marginBottom: 10 }}>
                    <div className="media">
                      <div className="media-body ml-3">
                        <Row className="product-name">                                                        
                          <Col md={3}>
                            <h6 className="mt-2" style={{ fontSize: 14 }}>
                              {item.sku.toUpperCase()}
                            </h6>
                          </Col>
                          {isThirdPartySeller && (
                            <Col md={3}>
                              <input
                                name="name"
                                defaultValue={
                                  getValues("bin_numbers").find((binItem) => binItem.size_id == item.size && binItem.colour_id == colourId)
                                    ?.gtn_number
                                }
                                type="text"
                                onChange={(event) => {
                                  updateBinDetails(item.size, event.target.value, 0);
                                }}
                                placeholder="GTIN #"
                                className={`form-control`}
                              />
                            </Col>
                          )}
                          {!isThirdPartySeller && (
                            <Col md={3}>
                              <h6 className="mt-2" style={{ fontSize: 14 }}>
                                {
                                  getValues("bin_numbers").find((binItem) => binItem.size_id == item.size && binItem.colour_id == colourId)
                                    ?.gtn_number
                                }
                              </h6>
                            </Col>
                          )}
                          <Col md={3}>
                            <CustomTagsInput
                              value={isChange || !isChange ? binValue(item) : []}
                              placeholder="Enter Bin Number"
                              tagChangeEvent={(value) => {
                                updateBinDetails(item.size, value, 1);
                                setIsChange(!isChange);
                              }}
                            ></CustomTagsInput>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            ))}

{sku?.length > 0 && (<Row className="mb-1">
              <Col sm={12}>
                <hr/>
                <h6>Available In Looks</h6>
              </Col>
              <Col sm={12}>
                <Select
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    defaultValue={
                      getValues("bin_numbers").find((binItem) => binItem.size_id == sku[0].size && binItem.colour_id == colourId)
                        ?.available_in_looks || []
                    }
                    menuPortalTarget={document.body}
                    isMulti={true}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    onChange={(e) => {
                      updateBinDetails(sku[0].size, e, 0, true);
                    }}
                    onInputChange={handleInputChangeLooklabProducts}
                    onMenuScrollToBottom={handleMenuScrollToBottomLooklabProducts}
                    onMenuOpen={handleMenuOpenLooklabProducts}
                    isLoading={loadingLooklabProducts}
                    // className={` ${errors.color_wise_looklab_products ? "is-invalid" : ""}`}
                    options={looklabProductsOptions}
                    noOptionsMessage={() => "No product found"}
                  />
              </Col>
            </Row>
            )}
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col md={12}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    skuOnClick(rowIndex, colourId, colourName);
                    closDialog();
                  }}
                >
                  Save
                </button>
              </Col>
            </Row>
          </ModalFooter>
          <Row className=" mb-3 mt-3">
            <Col md={12}>
              <div className="text-center">
                <span>{"Temporary save only! For permanent save, use the Publish or save button."}</span>
              </div>
            </Col>
          </Row>
        </Modal>
      </div>
    </Fragment>
  );
};

function areEqual(prevProps, nextProps) {
  return JSON.stringify(prevProps.getValues) == JSON.stringify(nextProps.getValues);
  /*
    return true if passing nextProps to render would return
    the same result as passing prevProps to render,
    otherwise return false
    */
}

export default React.memo(SkuDetails, areEqual);
